import { BoxButton, Description } from '@repo/ui';

import ErrorContactUsButtonContent from '@/components/tax-refund/common/error/ErrorContactUsButtonContent';
import { ErrorBaseViewController } from '@/lib/types/layout.ts';

const ErrorBaseView = ({ viewController }: { viewController: ErrorBaseViewController }) => {
  const {
    graphic,
    title,
    description,
    primaryButtonText,
    onPrimaryButtonClick,
    disabledPrimaryButton = false,
    primaryButtonVariant = 'filled-primary',
    secondaryButtonText,
    onSecondaryButtonClick,
    footerClickEvent
  } = viewController;

  return (
    <section className="w-full container-medium container-padding-large py-spacious-medium">
      <Description
        className="p-6"
        title={title}
        description={description}
        graphic={graphic}
        button={
          primaryButtonText && onPrimaryButtonClick ? (
            <BoxButton variant={primaryButtonVariant} size="medium" disabled={disabledPrimaryButton} onClick={onPrimaryButtonClick}>
              {primaryButtonText}
            </BoxButton>
          ) : undefined
        }
      />

      {secondaryButtonText && (
        <div className="mt-normal-medium">
          <BoxButton variant="tonal-secondary" size="medium" onClick={onSecondaryButtonClick}>
            {secondaryButtonText}
          </BoxButton>
        </div>
      )}

      {footerClickEvent && <ErrorContactUsButtonContent clickEvent={footerClickEvent} />}
    </section>
  );
};

export default ErrorBaseView;
